import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { InputLabelProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardInputLabel = dynamic(
  () => import("./DashboardInputLabelSsr").then((mod) => mod.DashboardInputLabelSsr),
  { ssr: false }
);

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardInputLabel = forwardRef<HTMLDivElement, InputLabelProps>((props, ref) => (
  <DynamicDashboardInputLabel {...props} forwardedRef={ref} />
));

DashboardInputLabel.displayName = "DashboardInputLabel";
